import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf';

export const servicesHomepageEnglish = [
    {
        'id': 'issue_virtual_epc',
        'title': 'Issue your virtual EPC',
        'description': 'Energy Performance Certificate quickly and easily via a user intuitive UI.',
        'icon': <DocumentScannerIcon style={{color: 'white', fontSize: '80px'}}/>,
        'image': '/images/homepageItems/homepageItem1.jpg',
        'link': '/building-info'
    },
    {
        'id': 'visualize_energy_savings',
        'title': 'Visualize energy savings',
        'description': 'Charts and useful information about your energy savings.',
        'icon': <EnergySavingsLeafIcon style={{color: 'white', fontSize: '80px'}}/>,
        'image': '/images/homepageItems/homepageItem2.jpg',
        'link': ''
    },
]

export const servicesHomepageLatvian = [
    {
        'id': 'issue_virtual_epc',
        'title': 'Izsniedziet savu virtuālo Ēkas energosertifikātu',
        'description': 'Energoefektivitātes sertifikāts ātri un vienkārši, izmantojot lietotājam draudzīgu lietotāja saskarni.',
        'icon': <DocumentScannerIcon style={{color: 'white', fontSize: '80px'}}/>,
        'image': '/images/homepageItems/homepageItem1.jpg',
        'link': '/building-info'
    },
    {
        'id': 'visualize_energy_savings',
        'title': 'Enerģijas ietaupījuma vizualizēšana',
        'description': 'Diagrammas un noderīga informācija par enerģijas ietaupījumu.',
        'icon': <EnergySavingsLeafIcon style={{color: 'white', fontSize: '80px'}}/>,
        'image': '/images/homepageItems/homepageItem2.jpg',
        'link': ''
    },
]